import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

/* When these figures were last known good, and a way to ask again.

   A dashboard without this is quietly lying the moment a call lands: the
   number was true once and says nothing about when. */
export default function UpdatedAt({ at, onRefresh, stale = false }) {
  const [, tick] = useState(0);

  // Re-render so "2 minutes ago" doesn't itself go stale.
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 15000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontFamily: 'var(--font-mono)', fontSize: 12 }}>
      <span style={{ color: stale ? 'var(--amber)' : 'var(--ink-soft)' }}>
        {stale ? "Couldn't refresh — showing " : 'Updated '}
        {ago(at)}
      </span>
      <button
        type="button"
        onClick={onRefresh}
        aria-label="Refresh"
        title="Refresh"
        style={{
          border: 'none', background: 'none', cursor: 'pointer', padding: 2,
          display: 'flex', color: 'var(--ink-soft)',
        }}
      >
        <RefreshCw size={13} />
      </button>
    </div>
  );
}

function ago(at) {
  if (!at) return 'never';
  const secs = Math.floor((Date.now() - at.getTime()) / 1000);
  if (secs < 10) return 'just now';
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins} minute${mins === 1 ? '' : 's'} ago`;
  return at.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}
